<template>
  <div class="dd-selector">
    <!--  title and badge icon  -->
    <b-arrow-down :title="title" :value="value" />
    <!--  native single select dropdown  -->
    <i-select
      class="dd-selector__select"
      :name="filterQueryKey"
      :value="value"
      :options="options"
      :placeholder="placeholder"
      @input="onInput"
    />
  </div>
</template>

<script>
import ArrowDownButton from '../../components/button/arrowDownButton'
import SelectInput from '../../components/input/select/selectInput'

export default {
  components: {
    'b-arrow-down': ArrowDownButton,
    'i-select': SelectInput,
  },
  methods: {
    /**
     * received select click
     */
    onInput(newValue) {
      this.$emit('input', {
        filterQueryKey: this.filterQueryKey,
        value: newValue,
      })
    },
  },
  props: {
    /**
     * filter query key
     */
    filterQueryKey: {
      default: '',
      type: String,
    },
    /**
     * all selection options
     */
    options: {
      default: () => [],
      type: Array,
    },
    /**
     * Input placeholder value
     */
    placeholder: {
      default: '',
      type: String,
    },
    /**
     * title
     */
    title: {
      default: '',
      type: String,
    },
    /**
     * Default input value
     */
    value: {
      default: '',
      type: [String, Number],
    },
  },
}
</script>

<style lang="postcss" scoped>
.dd-selector {
  @apply relative;

  & .dd-selector__select {
    @apply absolute inset-0 opacity-0 z-1;
  }
}

@screen desktop {
  .dd-selector:hover {
    & .b.b-arrow-down:after {
      @apply opacity-10;
    }
  }
}
</style>
